/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { BrokerPsp } from "./BrokerPsp";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const BrokersPspR = t.interface({
  brokers_psp: t.readonlyArray(BrokerPsp, "array of BrokerPsp"),

  page_info: PageInfo
});

// optional attributes
const BrokersPspO = t.partial({});

export const BrokersPsp = t.intersection(
  [BrokersPspR, BrokersPspO],
  "BrokersPsp"
);

export type BrokersPsp = t.TypeOf<typeof BrokersPsp>;
